import React from 'react'
import { ReviewAward } from './ReviewAward'

export const ReviewGrantsContracts = ({ values, ...props }) => {
  // The award fields either have suffix numbers, or is an array of objects.
  let awards = []
  if (values['award_type_0'] !== undefined) {
    for (let id = 0; id <= 9; id++) {
      const award_type = values[`award_type_${id}`]
      const award_number = values[`award_number_${id}`]
      const executive_director = values[`executive_director_${id}`]
      if (award_type !== '') {
        awards.push({
          award_type: award_type,
          award_number: award_number,
          executive_director: executive_director
        })
      }
    }
  } else {
    awards = values.awards
  }

  return awards.map((award, index) => {
    let editFieldName = `award_type_${index}`
    if (values[`award_type_${index}`] === undefined)
      editFieldName = `awards.${index}.award_type`
    const awardProps = {
      ...award,
      ...props,
      editFieldName
    }
    return (
      <section key={editFieldName}>
        <ReviewAward {...awardProps} />
      </section>
    )
  })
}
